'use client'

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import { forwardRef, SVGProps, Ref } from 'react'
const PrivateVan = forwardRef((props: SVGProps<SVGSVGElement>, svgRef: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32" ref={svgRef} {...props}>
    <path
      fill="currentColor"
      d="M7.579 21.484a1.233 1.233 0 100-2.466 1.233 1.233 0 000 2.466zm0-3.602a2.37 2.37 0 110 4.739 2.37 2.37 0 010-4.739zm17.369 0a2.369 2.369 0 11-.001 4.737 2.369 2.369 0 01.001-4.737zm0 3.602a1.233 1.233 0 100-2.466 1.233 1.233 0 000 2.466zm5.734-6.447c.182.04.318.203.318.396v4.289a.406.406 0 01-.405.405l-2.662-.06a2.984 2.984 0 00-5.958.04H10.988l-.242-.179a2.986 2.986 0 00-5.95.344c0 .119.008.236.021.351l-.248.196L1 20.456c.111-.184 0-12.457 0-12.457h18.759c2.077 0 5.291 1.718 6.107 2.175h-4.283s-.569.022-.569.458.038.818.108 1.287c.071.469.298.961 1.189 1.172.351.083 8.369 1.945 8.369 1.945z"
    />
  </svg>
))
export default PrivateVan
